@import '../../../../../../constants/spacing.module.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../settings-page.module.less';

.table {
  border: @settings-page--table--border;
  background-color: @settings-page--table--body--cell--background-color;
}

.table-column-header {
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
  font-weight: @settings-page--table--header--cell--font-weight;
  color: @settings-page--table--header--cell--text-color;
  background-color: @settings-page--table--header--cell--background-color;
  border-bottom: 1px solid @settings-page--table--border-color;
}

.table-column-header > div:last-child {
  text-align: right;
}

.table-body-cell {
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
  color: @settings-page--table--body--cell--text-color;
}

.table-body-cell:last-child {
  text-align: right;
}
